import { gql } from '__generated__'

export const Attributes = gql(/* GraphQL */ `
    query Attributes($candidateId: ID) {
        candidate(id: $candidateId) {
            id
            analystClassYear
            citizenships {
                citizenship {
                    id
                    value
                }
                id
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            dealSourcingRole {
                dealSourcingRole {
                    id
                    value
                }
                createdAt
                createdByUser {
                    firstName
                    lastName
                    nickname
                }
                updatedAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            referenceAttribute {
                referenceAttribute {
                    id
                    value
                }
                createdAt
                createdByUser {
                    firstName
                    lastName
                    nickname
                }
                updatedAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            cpiPlaced {
                createdAt
                createdByUser {
                    firstName
                    lastName
                    nickname
                }
                updatedAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                cpiPlaced {
                    id
                    value
                }
            }
            revenueExperiences {
                createdAt
                createdByUser {
                    firstName
                    lastName
                }
                updatedAt
                updatedByUser {
                    firstName
                    lastName
                }
                revenueExperience {
                    id
                    value
                }
            }
            personalityAttributes {
                personalityAttribute {
                    id
                    value
                }
                createdAt
                updatedAt
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            realEstateDealExperiences {
                realEstateDealExperience {
                    id
                    value
                }
                createdAt
                updatedAt
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            gender {
                id
                genderId
                gender {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            tier {
                id
                tier {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            ethnicities {
                ethnicity {
                    value
                    id
                }
                id
                ethnicityId
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            hometown {
                country {
                    id
                    value
                }
                state {
                    id
                    value
                }
                province {
                    id
                    value
                }
                city
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            visaStatuses {
                id
                visaStatus {
                    value
                    id
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            veteranStatus {
                id
                veteranStatus {
                    value
                    id
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            languages {
                id
                language {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            higModelTest {
                higModelTest {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            higReferral {
                higReferral {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            higTeams {
                higTeam {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            lgbtq {
                lgbtq {
                    id
                    value
                }
                updatedAt
                createdAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
                createdByUser {
                    firstName
                    nickname
                    lastName
                }
            }
            mbaTier {
                mbaTier {
                    id
                    value
                }
                createdAt
                createdByUser {
                    firstName
                    lastName
                    nickname
                }
                updatedAt
                updatedByUser {
                    firstName
                    nickname
                    lastName
                }
            }
        }
        citizenships {
            id
            value
        }
        personalityAttributes {
            id
            value
        }
        realEstateDealExperiences {
            id
            value
        }
        genders {
            id
            value
        }
        ethnicities {
            id
            value
        }
        tiers {
            id
            value
        }
        countries {
            id
            value
        }
        states {
            id
            value
        }
        provinces {
            id
            value
        }
        visaStatuses {
            id
            value
        }
        veteranStatuses {
            id
            value
        }
        languages {
            id
            value
        }
        higModelTests {
            id
            value
        }
        higReferrals {
            id
            value
        }
        higTeams {
            id
            value
        }
        lgbtq {
            id
            value
        }
        revenueExperiences {
            id
            value
        }
        cpiPlaced {
            id
            value
        }
        referenceAttributes {
            id
            value
        }
        dealSourcingRoles {
            id
            value
        }
        mbaTiers {
            id
            value
        }
    }
`)

export const UpdateCitizenship = gql(/* GraphQL */ `
    mutation UpdateCitizenship($input: UpdateCitizenshipInput!) {
        updateCitizenship(input: $input) {
            success
            message
        }
    }
`)

export const UpdateGender = gql(/* GraphQL */ `
    mutation UpdateGender($input: UpdateGenderInput!) {
        updateGender(input: $input) {
            success
            message
        }
    }
`)

export const UpdateEthnicity = gql(/* GraphQL */ `
    mutation UpdateEthnicity($input: UpdateEthnicityInput!) {
        updateEthnicity(input: $input) {
            success
            message
        }
    }
`)

export const UpdateLanguages = gql(/* GraphQL */ `
    mutation UpdateLanguages($input: UpdateLanguagesInput!) {
        updateLanguages(input: $input) {
            success
            message
        }
    }
`)

export const UpdateVisaStatus = gql(/* GraphQL */ `
    mutation UpdateVisaStatus($input: UpdateVisaStatusInput!) {
        updateVisaStatus(input: $input) {
            success
            message
        }
    }
`)

export const UpdateVeteranStatus = gql(/* GraphQL */ `
    mutation UpdateVeteranStatus($input: UpdateVeteranStatusInput!) {
        updateVeteranStatus(input: $input) {
            success
            message
        }
    }
`)

export const UpdateTier = gql(/* GraphQL */ `
    mutation UpdateTier($input: UpdateTierInput!) {
        updateTier(input: $input) {
            success
            message
        }
    }
`)

export const UpdateHigTeam = gql(/* GraphQL */ `
    mutation UpdateHigTeam($input: UpdateHigTeamInput!) {
        updateHigTeam(input: $input) {
            success
            message
        }
    }
`)

export const UpdateHigReferral = gql(/* GraphQL */ `
    mutation UpdateHigReferral($input: UpdateHigReferralInput!) {
        updateHigReferral(input: $input) {
            success
            message
        }
    }
`)

export const UpdateHigModelTest = gql(/* GraphQL */ `
    mutation UpdateHigModelTest($input: UpdateHigModelTestInput!) {
        updateHigModelTest(input: $input) {
            success
            message
        }
    }
`)

export const UpdateLgbtq = gql(/* GraphQL */ `
    mutation UpdateLgbtq($input: UpdateLgbtqInput!) {
        updateLgbtq(input: $input) {
            success
            message
        }
    }
`)

export const UpdateHometown = gql(/* GraphQL */ `
    mutation UpdateHometown($input: UpdateHometownInput!) {
        updateHometown(input: $input) {
            success
            message
        }
    }
`)

export const UpdatePersonalityAttributes = gql(/* GraphQL */ `
    mutation UpdatePersonalityAttributes(
        $input: UpdatePersonalityAttributesInput!
    ) {
        updateCandidatePersonalityAttributes(input: $input) {
            success
            message
        }
    }
`)

export const UpdateRealEstateDealExperience = gql(/* GraphQL */ `
    mutation UpdateRealEstateDealExperience(
        $input: UpdateRealEstateDealExperienceInput!
    ) {
        updateCandidateRealEstateDealExperience(input: $input) {
            success
            message
        }
    }
`)

export const UpdateRevenueExperience = gql(/* GraphQL */ `
    mutation UpdateRevenueExperience($input: CandidateRevenueExperienceInput!) {
        updateCandidateRevenueExperience(input: $input) {
            success
            message
        }
    }
`)

export const UpdateCpiPlaced = gql(/* GraphQL */ `
    mutation UpdateCpiPlaced($input: UpdateCpiPlacedInput!) {
        updateCpiPlaced(input: $input) {
            success
            message
        }
    }
`)

export const UpdateReferenceAttribute = gql(/* GraphQL */ `
    mutation UpdateReferenceAttribute($input: UpdateReferenceAttributeInput!) {
        updateReferenceAttribute(input: $input) {
            success
            message
        }
    }
`)

export const UpdateCandidateMbaTier = gql(/* GraphQL */ `
    mutation UpdateCandidateMbaTier($input: UpdateCandidateMbaTierInput!) {
        updateCandidateMbaTier(input: $input) {
            success
            message
        }
    }
`)

export const UpdateDealSourcingRole = gql(/* GraphQL */ `
    mutation UpdateDealSourcingRole($input: UpdateDealSourcingRoleInput!) {
        updateDealSourcingRole(input: $input) {
            success
            message
        }
    }
`)

export const UpdateAnalystClassYear = gql(/* GraphQL */ `
    mutation UpdateAnalystClassYear(
        $candidateId: ID!
        $analystClassYear: Float
    ) {
        updateAnalystClassYear(
            candidateId: $candidateId
            analystClassYear: $analystClassYear
        ) {
            success
            message
        }
    }
`)
